import type { RecaptchaInfo } from '@/types/AuthType';

export type OtpFlowConfigParams = {
  channel?: OtpChannelType;
  inputsToHide?: ShippingOtp[];
  request?: RequestTypeEnum;
  businessFlow?: BusinessFlowType;
  showFirstButtons?: boolean;
  hasLoaderHandler?: boolean;
  /**
   * El popup monta el desafío reCAPTCHA V2 en su propia sección cuando el
   * backend rechaza el token V3. Opt-in: sin el flag, el flujo maneja su
   * recaptcha por fuera y el popup no interviene.
   */
  shouldMountRecaptcha?: boolean;
};

export type ShippingOtp = 'WHATSAPP' | 'SMS' | 'EMAIL';

export type OtpChannelType = 'WHATSAPP' | 'SMS' | 'EMAIL';

export type AuthTwoFactorType = 'WHATSAPP' | 'SMS' | 'EMAIL' | 'PIN';

export type TwoFactorAuthType = 'OTP' | 'PIN';

export const BusinessFlow = {
  CONTACT_LIST_CREATE_B2B: 'CONTACT_LIST_CREATE_B2B',
  VERIFY_PHONE_B2B: 'VERIFY_PHONE_B2B',
  SIGN_IN: 'SIGNIN',
  SIGN_IN_B2B: 'SIGN_IN_B2B',
  REGISTER_B2B: 'REGISTER_B2B',
  PASSWORD_FORGOT: 'PASSWORD_FORGOT',
  PASSWORD_RECOVER: 'PASSWORD_RECOVER',
  BENEFICIARY_CREATE_B2B: 'BENEFICIARY_CREATE_B2B',
  BENEFICIARY_EDIT_B2B: 'BENEFICIARY_EDIT_B2B',
  BENEFICIARY_LINK_B2B: 'BENEFICIARY_LINK_B2B',
  TRANSFER_LOCAL_CCA: 'TRANSFER_LOCAL_CCA',
  TRANSFER_LOCAL_ACH: 'TRANSFER_LOCAL_ACH',
  CARD_PIN_CHANGE_CO: 'CARD_PIN_CHANGE_CO',
  CARD_PIN_CHANGE_PE: 'CARD_PIN_CHANGE_PE',
  CARD_PIN_FORGOT: 'CARD_PIN_FORGOT',
  MULTI_TRANSACTION_B2B: 'MULTI_TRANSACTION_B2B',
  RFQ_REMITTANCE: 'RFQ_REMITTANCE',
  P2P_B2B: 'P2P_B2B',
  REMITTANCE_B2B: 'REMITTANCE_B2B',
  EXCHANGE_B2B: 'EXCHANGE_B2B',
  RESET_PIN_B2B: 'RESET_PIN_B2B',
  UPDATE_PIN_B2B: 'UPDATE_PIN_B2B',
  INVITATION: 'INVITATION',
  MINI_ONBOARDING_B2B: 'MINI_ONBOARDING_B2B',
  MULTI_CARD_CREATE_B2B: 'MULTI_CARD_CREATE_B2B',
  CARD_LIMIT_RESTRICTION_UPDATE_B2B: 'CARD_LIMIT_RESTRICTION_UPDATE_B2B',
  UPDATE_DISPOSABLE_B2B: 'UPDATE_DISPOSABLE_B2B',
  OTP_MS_AUTH: 'OTP_MS_AUTH',
  API_SECRET_REQUESTED: 'API_SECRET_REQUESTED',
  WEBAUTHN_REAUTH_B2B: 'WEBAUTHN_REAUTH_B2B',
} as const;

export type BusinessFlowType = (typeof BusinessFlow)[keyof typeof BusinessFlow];

export enum OtpChannelEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
}

export enum TwoFactorAuthEnum {
  OTP = 'OTP',
  PIN = 'PIN',
}

// OTP FLOW
export enum RequestTypeEnum {
  'AUTH' = 'AUTH',
  'WITH_SESSION' = 'WITH_SESSION',
  '2FA' = '2FA',
  'AUTH_V2' = 'AUTH_V2',
}

export interface INextOtp {
  otp: string;
  type: ShippingOtp;
  recaptchaInfo?: RecaptchaInfo;
}

export interface OtpEmits {
  (e: 'close'): void;
}

// Service
export interface UpdateCustomerPhonePayload {
  callingCode: string | null;
  phone: string | null;
}

export interface BaseOtpParams {
  channel: ShippingOtp;
}

export interface LegacyOtpParams extends BaseOtpParams {
  business_flow: string;
  token?: string;
  recaptchaInfo?: RecaptchaInfo;
}

export interface NewOtpParams extends BaseOtpParams {
  businessFlow: string;
  recaptchaInfo?: RecaptchaInfo;
}

export type PostOtpParams = LegacyOtpParams | NewOtpParams;
